import React, { useEffect, useState } from "react";
import { fetchCmsContent } from "../services/fetchCmsContent";
import MainPageComponents from "../components/CommonComponents/MainPageComponents";

interface ServicesItem {
  title: string;
  slug: string;
  content: string;
}

const ServicesPage: React.FC = () => {
  const [service, setService] = useState<ServicesItem | null>(null);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    fetchCmsContent("Our Services", "/api/cms/our-services", setService, setLoading);
  }, []);

  return (
    <MainPageComponents
      title={service?.title || "Our Services"}
      content={service?.content || ""}
      loading={loading}
      updated_at=""
    />);
};

export default ServicesPage;
